import { Measures } from "../../telemetry/Measures";
import { dashboard } from "../../telemetry/TraceLogging";
import { getHostAuthenticatorApiV2 } from "../externalApi/AuthenticatorApi";
export async function getUserInfo() {
    let userInfo = undefined;
    const authenticatorApi = await getHostAuthenticatorApiV2();
    const authenticator = window.__com_microsoft_dsh_widgetModelApiFactory.tryGetApi("authenticator", 1, 1);
    if (authenticator) {
        const accountId = await authenticator.getDefaultAccountIdAsync();
        if (accountId !== "") {
            const [userPrincipalName, userProfileImage] = await Promise.all([
                authenticator.getAccountPropertyAsync(accountId, "UPN"),
                authenticator.getAccountPictureAsync(accountId)
            ]);
            userInfo = {
                userPrincipalName,
                userProfileImage
            };
        }
        // else return userInfo as undefined
    }
    else if (authenticatorApi) {
        const defaultAccountId = await authenticatorApi.getDefaultAccountId();
        if (defaultAccountId !== null) {
            userInfo = await new Promise(async (resolve, reject) => {
                let info = {};
                info.userPrincipalName = await authenticatorApi.getAccountProperty(defaultAccountId, "UPN");
                authenticatorApi.getAccountPictureAsync(defaultAccountId, (imageString) => {
                    info.userProfileImage = imageString;
                    resolve(info);
                });
            });
        }
        // else return userInfo as undefined
    }
    else {
        // Auth APIs are not available, so return undefined to indicate that we're effectively signed out.
        Measures.logEvent(dashboard, "WebAppGetUserInfoFailed", 16777216 /* productAndServicePerformance */);
    }
    return userInfo;
}
